import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT, HIDE_ALO } from '../../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import AloComponent from '../alo/AloComponent';
import HeadComponent from '../../../HeadComponent';
import ProfileFormComponent from './ProfileFormComponent';
import LinkButtonComponent from '../../../button/LinkButtonComponent';
import UpdatePasswordFormComponent from './UpdatePasswordFormComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

import './ProfilePage.scss';

export class ProfilePage extends React.Component {
    render() {
        const { i18n, i18nAlo } = this.props;

        return (
            <main id="p-compte-monprofil">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ACCOUNT_PROFILE_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_PROFILE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>

                <h3>{i18n.SUBTITLE_PERSONNAL_INFORMATION}</h3>
                <ProfileFormComponent />

                <h3>{i18n.SUBTITLE_UPDATE_PASSWORD}</h3>
                <UpdatePasswordFormComponent />

                {!HIDE_ALO && (
                    <React.Fragment>
                        <h3>{i18n.SUBTITLE_ALO}</h3>
                        <div className="alo-button">
                            <p>{convertHtmlToReactDomWithParams(i18nAlo.ALO_TEXT)}</p>
                            <LinkButtonComponent
                                to={PATH.ALO_PATH}
                                text={i18nAlo.ALO_BUTTON}
                                title={i18nAlo.ALO_BUTTON}
                                color="sixth"
                            />
                        </div>
                        <AloComponent />
                    </React.Fragment>
                )}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        i18nAlo: state.i18n.page.ACCOUNT.ALO
    };
};

export default connect(mapStateToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfilePage.js